import React from 'react'
import AllComp from '../components/AllComp'
import PageHead from './PageHead'
import ContactPage from './ContactPage'
import Footer from './Footer'

function AllContact() {
  return (
    <div>
      <AllComp/>;
      <PageHead/>;
      <ContactPage/>;
      <Footer/>;
    </div>
  )
}

export default AllContact
